module.exports = __webpack_public_path__ + "cancel-black.png?49e122772722867a333290b49fc9aaa6";